import { useEffect, useState } from "react";

import { getAuthStatus } from "./api";

export type AuthState =
  | { status: "loading" }
  | { status: "signed_in" }
  | { status: "signed_out" }
  | { status: "error"; error: Error };

/**
 * Checks `/auth/status` once on mount. Returns a loading state until the
 * backend responds. Errors surface as `status: "error"`; the caller decides
 * how to handle (most callers should treat as signed_out).
 */
export function useAuthStatus(): AuthState {
  const [state, setState] = useState<AuthState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    getAuthStatus()
      .then((res) => {
        if (cancelled) return;
        setState({ status: res.signed_in ? "signed_in" : "signed_out" });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const error = err instanceof Error ? err : new Error(String(err));
        setState({ status: "error", error });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
